<section class="portal">
    <header class="header">
        <app-header></app-header>
    </header>
    <main class="main">
        <router-outlet class="router"></router-outlet>
    </main>
</section>
<app-onboarding-checklist></app-onboarding-checklist>
<app-sidekick></app-sidekick>
<app-cookie-consent></app-cookie-consent>
